'use strict'
import React, { useState, useRef, useEffect } from 'react'
import { plusIcon } from '../../assets'
import styles from './styles.module.css'

const Accordion = ({
  index,
  openIndex,
  setOpenIndex,
  title,
  intro,
  accordionContent,
}) => {
  const [accordionHeight, setAccordionHeight] = useState(0)
  const isOpen = index === openIndex

  const toggleAccordion = () => {
    setOpenIndex(isOpen ? null : index)
  }

  const contentRef = useRef(null)

  useEffect(() => {
    setAccordionHeight(isOpen ? contentRef.current.scrollHeight : 0)
  }, [isOpen])

  return (
    <div className={styles.accordion}>
      <div className={styles.accordionwrappercontainer}>
        <div
          key={index}
          className={styles.accordionwrapper}
          onClick={toggleAccordion}
        >
          <div>
            <span className={styles.accordiontitle}>{title}</span>
          </div>
          <div className={styles.accordionright}>
            {isOpen ? (
              <span className={styles.openIconwrapper}>
                <span className={styles.openIcon}></span>
              </span>
            ) : (
              plusIcon
            )}
          </div>
        </div>
        <div
          style={{ height: isOpen ? `${accordionHeight}px` : 0 }}
          ref={contentRef}
          key={`content-${index}`}
          className={styles.accordion_content}
        >
          {isOpen ? (
            <div className={styles.accordionContentwrapper}>
              <span className={styles.intro}>{intro}</span>
              <ul className={styles.accordionContent}>{accordionContent}</ul>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default Accordion
